export default __webpack_public_path__ + "static/media/how-it-works-image.48b6ebba.jpg";